type ImgSrcProps = {
    src: string;
    width?: number | string;
    height?: number | string;
    mode?: 'fill' | 'thumb' | 'crop' | 'scale' | 'limit' | 'fit' | 'pad';
    quality?: number;
    gravity?: 'north_east' | 'north' | 'north_west' | 'west' | 'south_west' | 'south' | 'south_east' | 'east' | 'center' | 'face' | 'face:center' | 'faces' | 'faces:center',
    background?: 'transparent' | 'none' | string;
    format?: 'auto' | 'jpg' | 'png' | 'svg' | 'webp' | string;
    extension?: 'jpg' | 'png' | 'svg' | 'webp' | string;
};

const imgSrc = ({ src, height, width, mode, quality, gravity, background, format, extension }: ImgSrcProps) => {
    if ( !src ) return src;

    const props = {
        width: typeof width === 'string' ? parseInt(width) : width,
        height: typeof height === 'string' ? parseInt(height) : height,
        // pixelRatio: typeof window !== 'undefined' ? window.devicePixelRatio : 1,
        mode: mode || 'limit',
        quality: quality || 85,
        gravity: gravity || undefined,
    };

    const regex = /([\S]+res\.cloudinary\.com[\S]+\/image\/upload\/)\S*(v\d+\/[\S]+)(\.[\S]+)/ig;
    const match = regex.exec(src);


    if (match && match[1] && match[2]) {
        const isSvg = match[3] === '.svg';

        const m = props.mode && (props.width || props.height) ? `c_${props.mode}` : null;
        const w = props.width ? `w_${Math.floor(props.width)}` : null;
        const h = props.height ? `h_${Math.floor(props.height)}` : null;
        const q = props.quality ? `q_${props.quality}` : null;
        const g = props.gravity && !isSvg ? `g_${props.gravity}` : null;
        const bg = background && background.indexOf('#') > -1 ? `b_rgb:${background.replace('#', '')}` : null;
        const f = format ? `f_${format}` : `${isSvg ? 'f_svg' : 'f_auto'}`;

        // Join and clean up unused stuff
        const crop = [m, w, h, q, g, bg, f].filter(i => !!i).join(',');

        
        return `${match[1]}${crop}/${match[2]}${extension ? `.${extension}` : ''}`;
    }

    return src.replace(/^http(?:s){0,1}\:/g, 'https:');
}

export default imgSrc;